module.exports = __webpack_public_path__ + "static/media/winSmall60_1.4674f300.png";